import React from 'react'
import { Copy } from 'iconsax-react'

import CommonButton from '../CommonButton'

import { Routes } from '@SonarCX/Routes'
import useTaskMultiEdit from '../hooks/useTaskMultiEdit'

const CopyLink: React.FC = () => {
  const { selected, suffix, showMessage, showError } = useTaskMultiEdit()

  const handleClick = React.useCallback(() => {
    const text = selected
      .map(id => `${window.location.origin}${Routes.TASKS}/${id}`)
      .join('\n')
    navigator.clipboard
      .writeText(text)
      .then(() => {
        showMessage(`Copied link${suffix}`)
      })
      .catch(err => {
        showError(err)
      })
  }, [selected, showMessage, suffix, showError])

  return (
    <CommonButton title='Copy link' Icon={Copy} onClick={handleClick}>
      <div>Copy link</div>
    </CommonButton>
  )
}

export default CopyLink
